module.exports = __webpack_public_path__ + "img/white-caret-down.eec5d619.svg";